// extracted by mini-css-extract-plugin
export default {"emptyStatesContainer":"TA37Mn"};